import { MemberActivityError } from './MemberActivityError';

export default MemberActivityError;
